
import { getPageLinks, getPageRobotMetaTag } from '@/utils/head-helpers';
import InterestRateWidget from '@/ui/widgets/interest-rate-widget';

export default {
  name: 'InterestRates',
  components: {
    InterestRateWidget,
  },
  layout: 'blank',
  head() {
    return {
      title: this.$t('seo.title'),
      titleTemplate: null,
      link: getPageLinks(
        this.routeURL,
        this.$i18n.locale,
        `${this.$config.HOST_NAME}${this.localePath(
          {
            name: 'embeddables-interest-rates',
          },
          'en',
        )}`,
        `${this.$config.HOST_NAME}${this.localePath(
          {
            name: 'embeddables-interest-rates',
          },
          'de',
        )}`,
      ),
      meta: [...getPageRobotMetaTag('noindex', 'nofollow')],
    };
  },
  mounted() {
    this.handleCookieConsent();
  },
  methods: {
    handleChartMounted() {
      const hasWindow = window && typeof window !== 'undefined';
      const hasParentWindow =
        hasWindow && window.top && typeof window.top !== 'undefined';

      if (hasParentWindow) {
        const height =
          document?.querySelector('#interest-chart')?.clientHeight ?? 600;
        const data = {
          key: 'interest-chart-dimensions',
          height,
        };
        window.top.postMessage(data, '*');
      }
    },

    handleCookieConsent() {
      if (typeof window === 'undefined') return;

      if (window.top !== window.self) {
        window.UC_UI?.closeCMP();
      }

      window.addEventListener('storage', (event) => {
        if (event.key === 'uc_settings') {
          window.UC_UI?.closeCMP();
        }
      });
    },
  },
};
